import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExternalLink } from "@fortawesome/free-solid-svg-icons";

export const Affiliate = (props) => {
  if( !props.supplies ) return <></>
  return (
    <div className='bg-felt-100 border border-felt-700 rounded'>
      <h3 className='bg-felt-700 text-white px-3 py-2 rounded-t font-bold'>Recommended Resources</h3>
      <ul className='px-3 py-2'>
      {props.supplies.map(({name, url}) => {
        return(
          <li key={url} className='pb-2'><a href={url} target="_blank" rel="noreferrer" className='!text-felt-700'>{name} <FontAwesomeIcon icon={faExternalLink} size="xs" className='ml-1' /></a></li>
        )
      })}
      </ul>
    </div>
  );
};
